import { apiCall, ApiConfig } from '../../config/api'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { typeVasActionTypes } from '../types/typeVasActionTypes'
import { TypeVas } from '../../interfaces/TypeVas/TypeVas'
import { getTypeVasAction } from '../actions/typeVasAction'

export function* getTypeVasAsync() {
  try {
    const { status, data }: AxiosResponse<TypeVas[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeVasApi}/GetDdlInfo`
    )
    if (status === 200) {
      yield put(getTypeVasAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeVasAction([], serverError.message))
  }
}

export function* watchGetTypeVasAsync() {
  yield takeEvery(typeVasActionTypes.GET_TYPE_VAS, getTypeVasAsync)
}
